export const marketingUrl =
  import.meta.env.VITE_MARKETING_URL || "http://localhost:5174";
